import apiClient from '../lib/apiClient';

const getDashboard = async () => {
  try {
    return await apiClient.get('/lifecycle/dashboard');
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to load lifecycle dashboard' };
  }
};

const hireApplicant = async (payload) => {
  try {
    return await apiClient.post('/lifecycle/hire', payload);
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to hire applicant' };
  }
};

const getOnboarding = async (employeeId) => {
  try {
    return await apiClient.get(`/lifecycle/onboarding/${employeeId}`);
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to load onboarding checklist' };
  }
};

const updateOnboardingItem = async (employeeId, payload) => {
  try {
    return await apiClient.put(`/lifecycle/onboarding/${employeeId}`, payload);
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to update onboarding item' };
  }
};

const linkAiSession = async (applicationId, sessionId) => {
  try {
    return await apiClient.post('/lifecycle/link-ai-session', {
      application_id: applicationId,
      session_id: sessionId,
    });
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to link AI session' };
  }
};

const transitionApplicant = async (applicationId, status, notes = '') => {
  try {
    return await apiClient.post('/lifecycle/transition', {
      application_id: applicationId,
      status,
      notes,
    });
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to update applicant status' };
  }
};

const getExitChecklist = async (employeeId) => {
  try {
    return await apiClient.get(`/lifecycle/exit-checklist/${employeeId}`);
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to load exit checklist' };
  }
};

const updateExitChecklistItem = async (employeeId, payload) => {
  try {
    return await apiClient.put(`/lifecycle/exit-checklist/${employeeId}`, payload);
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to update exit checklist' };
  }
};

export default {
  getDashboard,
  hireApplicant,
  getOnboarding,
  updateOnboardingItem,
  linkAiSession,
  transitionApplicant,
  getExitChecklist,
  updateExitChecklistItem,
};
